/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "./Contact.css";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";
const Contact = () => {
  return (
    <>
      <div className="contact" data-aos="fade-right"></div>

      <div className="Contact">
        <ul>
          <li>
            <a href="https://www.facebook.com/nisshongojiboner.pothik">
              <FacebookIcon />
            </a>
          </li>
          <li>
            <a href="https://www.instagram.com/">
              <InstagramIcon />
            </a>
          </li>
          <li>
            <a href="https://www.linkedin.com/in/riaz-ahmed-akhanda-752b84210/">
              <LinkedInIcon />
            </a>
          </li>
          <li>
            <a href="https://github.com/riazakhanda017ksn">
              <GitHubIcon />
            </a>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Contact;
